import React from 'react';
import { Button, ButtonToolbar, Card, CardBody, Col } from 'reactstrap';
import AssessmentTable from './AssessmentTable';
import { useAssessmentUIContext } from '../AssessmentUIProvider';

const AssessmentTableWrapper = () => {
  const assessmentUIContext = useAssessmentUIContext();

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody className="products-list">
          <div className="card__title">
            <h5 className="bold-text">Assessments List</h5>
            <ButtonToolbar className="products-list__btn-toolbar-top">
              <Button color="primary" onClick={assessmentUIContext.openNewAssessmentDialog}>
                Add new Assessments
              </Button>
            </ButtonToolbar>
          </div>
          <AssessmentTable />
        </CardBody>
      </Card>
    </Col>
  );
};

export default AssessmentTableWrapper;
